export function formatDate(date: Date): string {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");

	return `${y}/${m}/${d}`;
}

export function formatTime(date: Date): string {
	let hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, "0");

	const period = hours >= 12 ? "P.M." : "A.M.";

	hours = hours % 12 || 12;
	const hourStr = String(hours).padStart(2, "0");

	return `${hourStr}:${minutes} ${period}`;
}

export function getDurationHours(start: Date, end: Date): number {
	const duration = end.getTime() - start.getTime();
	return duration / (1000 * 60 * 60);
}

export function formatDuration(start: Date, end: Date): string {
	const hours = getDurationHours(start, end);
	return `${hours} Hour${hours !== 1 ? "s" : ""}`;
}
